import { sortBy, toUpper, uniqBy } from 'lodash';
export type EventResortProps = {
  id: string;
  name: string;
  openingStatus: string;
  destination: {
    area: string;
    areaId: string;
  };
};
export const getEventFormResorts = (resorts: Array<EventResortProps>): Array<EventFormResort> =>
  sortBy(
    uniqBy(resorts, 'id').map(({ id, name, destination, openingStatus }) => ({
      id,
      name,
      openingStatus,
      region: destination.area,
      regionId: destination.areaId.split('_').splice(3).join('_')?.toUpperCase(),
    })),
    (resort) => toUpper(resort.name),
  );
export const getEventFormRegions = (
  resorts: Array<EventFormResort>,
): Array<{
  name: string;
  value: string;
}> =>
  sortBy(
    uniqBy(resorts, (resort) => resort.regionId).map(({ region, regionId }) => ({
      name: region,
      value: regionId,
    })),
    (region) => toUpper(region.name),
  );
